'use client';

import { PurchaseButton } from '@libs/shared-ui';

import { useAddedToCartCTA, useIsFormValid } from '../../model';

export const AddToCartButton = () => {
    const { isValid } = useIsFormValid();
    const { isSubmitting, isSubmittedSuccessfully, ctaText, metaPurchaseDelivery } = useAddedToCartCTA();

    return (
        <PurchaseButton
            text={ctaText}
            disabled={!isValid}
            loading={isSubmitting}
            isSuccess={isSubmittedSuccessfully}
            formId="pdp-purchase-form"
            fulfillmentMethod={metaPurchaseDelivery}
            testId="add-to-cart-button"
        />
    );
};
